<template>
  <div class="recommendations-page" v-if="!showEmptyState">
    <div class="back-section">
      <router-link :to="'/favorites'" class="flex align-center back-link">
        <inline-svg width="40" height="40" :src="require('@/assets/img/icons/chevron_left.svg')" />
        <h4>ALL FAVORITES</h4>
      </router-link>
    </div>

    <h1 class="page-title">Brands You Follow</h1>
    <div class="page-content">
      <div class="controls-section">
        <search-input-field
          v-model="searchValue"
          class="search-input"
          :placeholder="isMobile ? 'Search brands' : 'Search'"
        />
        <sorting-options
          :options="sortingOptions"
          :is-mobile="isMobile"
          :hide-label="isMobile"
          no-pagination
          no-tracking
        />
      </div>

      <template>
        <div class="recommendations-grid margin-top-40" v-if="!favoriteBrandsLoading">
          <favorite-brand-tile :brand="brand" v-for="brand in filteredFavoriteBrands" />
          <div v-if="filteredFavoriteBrands && !filteredFavoriteBrands.length && searchValue">No results found.</div>
        </div>
        <div class="flex align-center justify-center padding-top-60" v-else>
          <loader-static />
        </div>
      </template>

      <template v-if="!recommendedBrandsLoading">
        <div v-if="showRecommendedBrandsCarousel">
          <div class="recommended-brands-carousel">
            <h4 class="font-size-12">BULLETIN EDITS</h4>
            <h1>Our Picks for You</h1>

            <div class="buttons-row flex align-center justify-between">
              <bulletin-button class="see-all-btn" :to="'/favorites/recommended-brands'">See All</bulletin-button>
              <favorite-carousel-control
                :carousel-ref="$refs.favoriteBrandsCarouselRef"
                :number-of-items="recommendedBrands.length"
              />
            </div>

            <favorite-brands-carousel
              :brands="recommendedBrands"
              ref="favoriteBrandsCarouselRef"
              :max-items="maxItemsOfRecommendedBrands"
              :see-all-link-to="'recommended-brands'"
            />
          </div>
        </div>

        <div v-else class="recommended-brands-grid">
          <div class="section-title">
            <h4 class="font-size-12">BULLETIN EDITS</h4>
            <div class="flex align-center justify-between margin-top-8">
              <h2 class="font-size-32">Our Picks for You</h2>
              <bulletin-button :to="'/favorites/recommended-brands'">See All</bulletin-button>
            </div>
          </div>

          <div class="recommendations-grid margin-top-24">
            <favorite-brand-tile :brand="brand" v-for="brand in firstFourRecommendedBrand" />
          </div>
        </div>
      </template>
    </div>
  </div>
  <favorite-brands-empty-state v-else class="no-border-bottom" />
</template>

<style scoped lang="scss" src="../favoritesSubPage.scss" />

<style scoped lang="scss">
@import "@/assets/sass/base/_vars.scss";
@import "@/assets/sass/base/_mixins.scss";

.page-title {
  font-size: 48px;
  line-height: 64px;
  padding-inline: 40px;

  @include respond-to("medium") {
    padding-inline: 16px;
    font-size: 32px;
    line-height: 40px;
  }
}

.recommended-brands-grid {
  border-top: 1px solid $color-grey;
  padding-block: 56px;
  margin-top: 56px;
}

.recommended-brands-carousel {
  padding-block: 40px;
  margin-top: 40px;
  border-top: 1px solid $color-grey;

  h1 {
    font-size: 32px;
    line-height: 40px;
    margin-top: 8px;
  }

  .buttons-row {
    margin-bottom: 24px;
    margin-top: 16px;
    .see-all-btn {
      width: 128px;
      min-width: unset !important;
    }
  }
}
</style>

<script>
import { favoritesPageHelper } from "../../favoritesPageHelper";
import FavoriteBrandTile from "../../favoriteBrandTile";
import InlineSvg from "vue-inline-svg";
import _debounce from "lodash/debounce";
import FavoriteBrandsEmptyState from "../../emptyStates/favoriteBrandsEmptyState";
import FavoriteCarouselControl from "../../favoriteCarouselControl";
import FavoriteBrandsCarousel from "../../favoriteBrandsCarousel";

export default {
  mixins: [favoritesPageHelper],
  components: {
    FavoriteBrandTile,
    InlineSvg,
    FavoriteBrandsEmptyState,
    FavoriteCarouselControl,
    FavoriteBrandsCarousel,
  },
  data() {
    return {
      searchValue: this.$route.query.keyword || "",
      brands: [],
      sortingOptions: [
        {
          name: "Most Recently Followed",
          value: "most_recently_followed",
        },
        {
          name: "New Arrivals",
          value: "made_active",
          direction: "DESC",
        },
        {
          name: "High Sell Through",
          value: "total_orders",
          direction: "DESC",
        },
        {
          name: "Lowest MOV",
          value: "minimum_order_value",
          direction: "ASC",
        },
        {
          name: "Lowest Lead Time",
          value: "lead_time_from",
          direction: "ASC",
        },
      ],
    };
  },
  beforeMount() {
    this.fetchBrandObjects();
    this.setDefaultSorting();
  },
  computed: {
    firstFourRecommendedBrand() {
      return this.recommendedBrands?.slice(0, 4);
    },
    filteredFavoriteBrands() {
      const favoriteBrands = [...this.favoriteBrands];
      return this.sortBrands(this.filterBrandsByKeyword(favoriteBrands));
    },
    showEmptyState() {
      return !this.favoriteBrandsLoading && !this.favoriteBrands?.length;
    },
    showRecommendedBrandsCarousel() {
      return this.underBreakpoint("md");
    },
    maxItemsOfRecommendedBrands() {
      return this.underBreakpoint("md") ? 4 : 8;
    },
  },
  watch: {
    searchValue: _debounce(function (value) {
      this.updateURLParams("keyword", value);
    }, 150),
  },
};
</script>
